import './not-results-history-points.scss'

import React from 'react'

export const NotResultsHistoryPoints = () => {
  return (
    <div className="club-card-user-history-points notResults">
      <p>Você não possui movimentação nesse mês</p>
    </div>
  )
}
